interface ArrowButtonProps {
  direction: "left" | "right";
  onClick: () => void;
}

export function ArrowButton(props: ArrowButtonProps) {
  return (
    <button
      class="hidden size-8 items-center justify-center rounded-full border border-stroke-2 bg-background-normal-primary text-text-normal-primary md:flex"
      onClick={props.onClick}
      aria-label={
        props.direction === "left" ? "Previous banner" : "Next banner"
      }
      style={{
        transform:
          props.direction === "left" ? "rotate(180deg)" : "rotate(0deg)",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.8332 9.99967H4.1665"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6665 14.1667L15.8332 10"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6665 5.83301L15.8332 9.99967"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
}
